/* eslint-disable no-underscore-dangle */
import has from "lodash-es/has";

/**
 * 以一个 Vue 实例作为起点，尝试解析 Vue inject 的结果
 *
 * @template T
 * @param {any} source 起点。注意，这个组件 provide 的东西也会参与解析
 * @param {string} provideKey
 * @param {T} [defaultValue] 如果找不到结果，返回
 * @return {T}
 */
export function resolveVueInject(source, provideKey, defaultValue) {
  while (source) {
    if (source._provided && has(source._provided, provideKey)) {
      return source._provided[provideKey];
    }
    // eslint-disable-next-line no-param-reassign
    source = source.$parent;
  }
  return defaultValue;
}
//# sourceMappingURL=resolveVueInject.js.map
